export default __webpack_public_path__ + "static/media/codeIcon.cc3b94a9.png";